// actions.js
export const setSelectedDropOff = (dropOff) => ({
    type: 'SET_SELECTED_DROPOFF',
    payload: dropOff,
  });
  